export type MarkerHeaderProps = {
  title: string;
  iconUrl: string;
};

export function MarkerHeader({ title, iconUrl }: MarkerHeaderProps) {
  return (
    <div className="d-flex align-items-center gap-1">
      <img src={iconUrl} alt="" className="mr-2" style={{ height: 28 }} />
      <h2 className="h6 mb-0" style={{ maxWidth: 230 }}>
        {title}
      </h2>
    </div>
  );
}
